export const PDF = ".pdf";
export const DOC = ".doc";
export const DOCX = ".docx";
export const XLSX = ".xlsx";
export const ZIP = ".zip";
export const RAR = ".rar";
export const JPEG = ".jpeg";
export const JPG = ".jpg";
export const PNG = ".png";

export const DEFAULT_FILE_FORMATS = [PDF, DOC, DOCX, XLSX, ZIP, RAR, JPEG, JPG, PNG];

export const DEFAULT_IMAGE_FORMATS = [JPEG, JPG, PNG];
export const DEFAULT_DOCUMENT_FORMATS = [PDF, DOC, DOCX, XLSX, ZIP, RAR];

export const FILE_SIZE = 12582912;

export const LARGE_FILE_ERROR = "file-too-large";
export const INVALID_FILE_ERROR = "file-invalid-type";
